<!-- 电表查询 -->
<template>
    <div class="inquireelectricityNum">
   <!-- 查询电表 -->
        <van-form @submit="onSubmit" class="form">
            <div class="labelBox">查询电费</div>
            <div class="checkBtn">
                <van-field class="inputBox" v-model="carForm.ammeter" name="ammeter" label="电表号："
                    placeholder="请输入您的电表号" />
                <van-button class="btnBox" round block type="info" native-type="submit" size="small">查询</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
  // 房间号
            carForm: {
                ammeter: ''
            },
        };
    },
    created() { },
    mounted() { },
    methods: {
     onSubmit() {
            if (this.carForm.ammeter =='') {
                this.$toast('请输入电表号')
                return
            }
           this.$router.push({path: './toUpElectricCharge'})

         
        }
    },
}
</script>

<style lang="less" scoped>
.inquireelectricityNum {
      .form {
        .labelBox {
            width: 100%;
            text-align: left;
            font-size: 0.5rem;
            color: #aaa;
            padding: 0.3rem 1rem;
        }

        .checkBtn {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            padding: 0 0.2rem;

            .inputBox {
                flex: 4;
            }

            .btnBox {
                flex: 1;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/electricCharge/inquireelectricityNum.vue